import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

const useMatchPath = (pathList: string[]): boolean => {
  const location = useLocation();

  return useMemo(
    () => pathList.some((path) => !!matchPath(path, location.pathname)),
    [location.pathname, pathList],
  );
};

export { useMatchPath };
